import React, { useState } from "react";
import "./PnLCompareDetails.scss";
import { useSelector } from "react-redux";
import {
    PnLElevationSelectButton,
    PnLElevationInfoContainer,
} from "../PnLFloorplanDetails/PnLFloorplanDetailsParts";
import { useScrollBoost } from "react-scrollbooster";

function PnLCompareFloorplanProductImageDisplay(props) {
    var classes = "PnLCompareFloorplanProductImageDisplay";
    if (props.active) classes += " active";

    return (
        <div className={classes}>
            <label className="label">{props.plan.label}</label>
            <img className="floorplan" src={props.plan.plan_image} />
        </div>
    );
}

function PnLCompareDetails(props) {
    var content = useSelector((state) => state.content);
    //var floorplans = useSelector((state) => state.floorplan.activeFloorplans);
    var floorplans = useSelector((state) => state.floorplan.compareFloorplans);
    var compareFloorplans = useSelector(
        (state) => state.floorplan.compareFloorplans
    );

    var activeCompare = useSelector(
        (state) => state.floorplan.activeCompareFloorplans
    );

    var activeFloorplanID = activeCompare[props.side].activeFloorplanID;
    var activeElevationID = activeCompare[props.side].activeElevationID;

    var [viewport] = useScrollBoost({
        direction: "all",
        friction: 0.05,
        scrollMode: "native",
    });

    if (
        typeof floorplans !== "undefined" &&
        floorplans.length > 0 &&
        activeFloorplanID != -1 &&
        activeElevationID != -1 &&
        typeof content !== "undefined"
    ) {
        var floorplan;
        if (props.side == "left") {
            floorplan = floorplans[activeFloorplanID];
        } else {
            floorplan = compareFloorplans[activeFloorplanID];
        }

        var elevation = floorplan.elevation[activeElevationID];
        var plans = elevation.floorplan_designs;

        return (
            <div className="PnLCompareDetails">
                <div className="info-container">
                    <div className="image-container">
                        <img
                            className="image"
                            src={elevation.elevation_image}
                        />
                    </div>
                    <div className="elevation-selection-bar">
                        {floorplan.elevation.map((elev, ekey) => (
                            <PnLElevationSelectButton
                                letter={elev.elevation_name}
                                index={ekey}
                                active={ekey == activeElevationID}
                                compare
                                side={props.side}
                            />
                        ))}
                    </div>
                    <div className="elevation-container">
                        {plans.map((plan, key) => (
                            <PnLElevationInfoContainer
                                floorplan={floorplan}
                                plans={plan}
                                elevation={elevation}
                                active={activeElevationID == key}
                                side={props.side}
                                compare
                            />
                        ))}
                    </div>
                </div>
                <div
                    className="floorplan-display-container-viewport"
                    ref={viewport}
                >
                    <div className="floorplan-display-container">
                        <div className="display-container">
                            {/*plans[activeElevationID].plans.map((plan, pkey) =>
                                <PnLCompareFloorplanProductImageDisplay
                                    key={pkey}
                                    plan={plan}
                                    active={true}
                                />
                            )*/}
                            {console.log(plans)}
                            {plans.map((plan, pkey) => (
                                <React.Fragment key={pkey}>
                                    {plan.plans.map((design, dkey) => {
                                        return (
                                            <PnLCompareFloorplanProductImageDisplay
                                                key={dkey}
                                                plan={design}
                                                active={true}
                                            />
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return <div />;
    }
}

export default PnLCompareDetails;

